import MetaDataProivder from '../../Components/MetaDataProvider';
import MainTemplate from '../../Template/MainTemplate';
import { Col, Container, Row, ThemeProvider } from 'react-bootstrap';
import { Trans, useTranslation } from "react-i18next";
import { toPng } from 'html-to-image';

import heroImage from "../../Assets/img/accessibility-checker-hero.svg";
import heroImageRtl from "../../Assets/img/accessibility-checker-hero-arabic.svg";
import LodingImg from "../../Assets/img/icon-spinner.svg";

import ScanURLFormComponents from '../../Components/ScanURLForm';

import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StoreProptypes } from '../../PropTypes/StoreProptypes';
import { ScanningProcessService } from '../../Services/ScanningProcessService';
import { Link, useNavigationType, useSearchParams } from 'react-router-dom';
import WebsiteURLSection from '../../Components/ScanDetails/WebsiteURLSecrion';

import AccessibilityViolationsList from '../../Components/ScanDetails/AccessibilityViolationsList';

import { groupDataMainPropTypes, requestDataProptype } from '../../PropTypes/ScanningScreenPropType';
import useWindowSize from '../../Helpers/useWindowSize';


//import ViolationsGroupListPlaceholder from '../../Components/Placeholder/ViolationsGroupList';
import ReactGA from "react-ga4";


import CustomLoader from '../../Components/CustomLoader';
import CustomHeader from '../../Components/CustomHeader';
import Footer from '../../Components/Footer';
import logo from "../../Assets/img/accessibility-checker-logo.svg";
import errorImage from "../../Assets/img/error-image.svg";
import DownloadReport from '../../Components/DownloadReport';
import AllInOneAccessibilityCTA from '../../Components/AllInOneAccessibilityCTA';
import aioaBanner from "../../Assets/img/AIOA-Banner-3.webp";
import manualBanner from "../../Assets/img/Manual-Accessibility-Audit-Report.webp";
import { BACKGROUNDCOLOR, IS_FROM_SCRIPT, LOADING, PID, PID_API_LOADING, SET_LANGUAGE, SET_STANDARD, SET_TOKEN, TEXTCOLOR, TITLE, WEBSITE_URL } from '../../Actions/Types';
import decodeBase64 from '../../Helpers/decodeBase64';
import { GetPartnerCheckerDetailsService } from '../../Services/GetPartnerCheckerDetailsService';
import aioaBannerRtl from "../../Assets/img/AIOA-Banner-Arabic.webp";
import manualBannerRtl from "../../Assets/img/Manual-Accessibility-Audit-Report-Arabic.webp";
import ScanningMonitoringBannerRtl from "../../Assets/img/Accessibility-Monitoring-Arabic.webp";


interface tempGropScorePropType {
  [keyname: string]: number[];
}
interface finalGropTotalScorePropType {
  [keyname: string]: number;
}

// Snapshot of the last finished scan. Lives outside the component so it survives
// unmount/remount (e.g. going to Privacy Policy and pressing the browser back button).
interface ScanSnapshot {
  key: string; // `${websiteURL}|${language}|${standard}`
  lang: string;  
  violationsGroupList: groupDataMainPropTypes;
  requestDataObj: requestDataProptype;
  errorViolationsTotal: number;
  successViolationsTotal: number;
  errorViolationsTotalFixedByWidget: number;
  accessibilitySystemDetected: string;
  accessibilityScore: number;
}
let scanSnapshot: ScanSnapshot | null = null;

// component to render all in one promotional banner
const AIOAPromoBanner = () => {
  const { i18n } = useTranslation();
  const isRtl = i18n.dir() === 'rtl';

  return (
    <div
      className="aioa-promo-banner"
      role="region"
      aria-label="Promotional banner for All in One Accessibility®. Learn more or try free."
    >
      <a
        href="https://ada.skynettechnologies.us/trial-subscription"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Start free trial"
      >
        <img src={isRtl ? aioaBannerRtl : aioaBanner} alt="" className="img-fluid" />
      </a>
    </div>
  );
};

const ManualAuditBanner = () => {
  const { i18n } = useTranslation();
  const isRtl = i18n.dir() === 'rtl';

  return (
    <div className="aioa-promo-banner">
      <a
        href="https://www.skynettechnologies.com/website-accessibility-audit"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={isRtl ? manualBannerRtl : manualBanner}
          alt="Manual Accessibility Audit"
          className="img-fluid"
        />
      </a>
    </div>
  );
};

function getWebsiteName(url:string) {
    // Remove protocol (http://, https://)
    let domain = url.replace(/^https?:\/\//, '');
    
    // Remove www.
    domain = domain.replace(/^www\./, '');
    
    // Get everything before the first slash or question mark
    domain = domain.split('/')[0];
    domain = domain.split('?')[0];
    
    return domain;
}

const Home = () => {

  ReactGA.initialize("G-85C9EMDGMJ", {
    gaOptions: {
      debug_mode: true,
    },
    gtagOptions: {
      debug_mode: true,
    },
  });

  const { scaningProcess, scaningProcessPer, websiteURL, reScaningProcess, isLoading, isPaidFree, pid, lang, title, ispidLoading, standard } = useSelector((store: StoreProptypes) => store);
  const [isFromScript, setIsFromScript] = useState<boolean>(false)
  const dispatch = useDispatch();

  const { windowWidth } = useWindowSize();


  const { t, i18n } = useTranslation();

  // Restore the finished report if we are coming back to the same site/language/standard
  const [initialSnapshot] = useState<ScanSnapshot | null>(() =>
      scanSnapshot && websiteURL && scanSnapshot.key === `${websiteURL}|${standard}`
      ? scanSnapshot
      : null
  );
  const restoredKey = useRef<string | null>(initialSnapshot ? initialSnapshot.key : null);

  // Always-fresh UI language (avoids stale closures in effects / setTimeout polling)
  const langRef = useRef<string>(i18n.language);
  langRef.current = i18n.language;
  // Language that the data currently on screen was scanned with
  const scanLangRef = useRef<string | null>(initialSnapshot ? initialSnapshot.lang  : null);

  const getScanLang = () => {
    scanLangRef.current = langRef.current;
    return langRef.current;
  };

  const [searchParams] = useSearchParams();
  const websiteURLParam = searchParams.get("website");
  const navigationType = useNavigationType(); // 'POP' = browser back/forward button
  
  const [isWhiteLabel, setIsWhiteLabel] = useState<boolean>(false)

  const changeLanguage = (
        langCode: string // language code
    ) => {
        i18n.changeLanguage(langCode);
        if (langCode !== lang) {
            dispatch({ type: SET_LANGUAGE, payload: langCode });
        }
    }


  useEffect(() => {
    if (websiteURLParam) {
      const urlParams = new URLSearchParams(window.location.search);
      const tokens = urlParams.get('token');
      if (tokens) {
        dispatch({ type: SET_TOKEN, payload: urlParams.get('token') })
        const decodeString = decodeBase64(tokens.toString())
        if (decodeString) {
          const params = new URLSearchParams(decodeString);
          const key = "is_white_label";
          setIsWhiteLabel(params.get(key) === 'true')
          const lang = params.get("langCode");
          if (lang) {
            changeLanguage(lang);
          }
          dispatch({ type: PID, payload: params.get("pId") })
          const standard = params.get("standard");
          if (standard) {
            dispatch({ type: SET_STANDARD, payload: params.get("standard") })
          }
          console.log('params.get("pId"): ', isWhiteLabel);
          if (params.get("isFromScript") === 'true') {
            setIsFromScript(true)
            dispatch({ type: IS_FROM_SCRIPT, payload: true })
          } else {
            setIsFromScript(false)
            dispatch({ type: IS_FROM_SCRIPT, payload: false })
          }
          if (params.get("pId") !== '' && params.get("pId") !== null) {
            dispatch({ type: PID_API_LOADING, payload: true })
            GetPartnerCheckerDetailsService(params.get("pId") || '').then((res:any) => {
              if (res?.style) {
                const styleTag = document.createElement("style");
                styleTag.innerHTML = res?.style;
                document.head.appendChild(styleTag);
              } else {
                if (res?.background_color) {
                  dispatch({ type: BACKGROUNDCOLOR, payload: res?.background_color })
                  const custom_color_style = document.createElement('style');
                  custom_color_style.id = "accessibility_checker_primary_color";

                  custom_color_style.textContent = `
                    :root {
                      --accessibility-checker-primary-color: ${res?.background_color};
                    }
                  `;

                  document.head.appendChild(custom_color_style);
                }
              }
              if (res?.title !== '') {
                dispatch({ type: TITLE, payload: res?.title })
              }
            }).catch(() =>{

            }).finally(() => {
              dispatch({ type: PID_API_LOADING, payload: false })
            })
          }

          const html = document.documentElement;
          if (html) {
              html.classList.add('isWhiteLabel');
          }
          
          console.log('Token found:', isWhiteLabel);
        }
      } else {
        console.log('No token in URL');
      }
      
      const cleanedUrl = websiteURLParam.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '');

      // Browser back/forward: keep the current report on screen instead of the loader
      if (navigationType === 'POP' && violationsGroupList) {
        // same site is already displayed -> nothing to reload
        if (cleanedUrl === websiteURL) return;
        startSilentRefetch();
      }

      dispatch({ type: WEBSITE_URL, payload: cleanedUrl })
      //ScanningProcessService((), 2, getScanLang(), dispatch, setViolationsGroupList, setErrorViolationsTotal, setErrorViolationsTotalFixedByWidget, setSuccessViolationsTotal, setAccessibilitySystemDetected, setRequestDataObj, setScreenError, setApiRecall);
      //console.log("API Call websiteURLParam ==>", websiteURLParam)
    }
  }, [websiteURLParam]);

  useEffect(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const tokens = urlParams.get('token');
      if (tokens) {
        dispatch({ type: SET_TOKEN, payload: urlParams.get('token') })
        const decodeString = decodeBase64(tokens.toString())
        if (decodeString) {
          const params = new URLSearchParams(decodeString);
          const key = "is_white_label";
          setIsWhiteLabel(params.get(key) === 'true')
          dispatch({ type: PID, payload: params.get("pId") })
          const standard = params.get("standard");
          if (standard) {
            dispatch({ type: SET_STANDARD, payload: params.get("standard") })
          }
          const lang = params.get("langCode");
          if (lang) {
            changeLanguage(lang);
          }
           if (params.get("isFromScript") === 'true') {
            setIsFromScript(true)
            dispatch({ type: IS_FROM_SCRIPT, payload: true })
          } else {
            setIsFromScript(false)
            dispatch({ type: IS_FROM_SCRIPT, payload: false })
          }

          if (params.get("pId") !== '' && params.get("pId") !== null) {
            dispatch({ type: PID_API_LOADING, payload: true })
            GetPartnerCheckerDetailsService(params.get("pId") || '').then((res:any) => {
              if (res?.style) {
                const styleTag = document.createElement("style");
                styleTag.innerHTML = res?.style;
                document.head.appendChild(styleTag);
              } else {
                if (res?.background_color) {
                  dispatch({ type: BACKGROUNDCOLOR, payload: res?.background_color })
                 const custom_color_style = document.createElement('style');
                  custom_color_style.id = "accessibility_checker_primary_color";

                  custom_color_style.textContent = `
                    :root {
                      --accessibility-checker-primary-color: ${res?.background_color};
                    }
                  `;

                  document.head.appendChild(custom_color_style);
                }
              }
              if (res?.title !== '') {
                dispatch({ type: TITLE, payload: res?.title })
              }
            }).catch(() =>{

            }).finally(() => {
              dispatch({ type: PID_API_LOADING, payload: false })
            })
          }

          const html = document.documentElement;
          if (html) {
              html.classList.add('isWhiteLabel');
          }

        }
      } else {
        console.log('No token in URL');
      }
  }, [])

  useEffect(() => {
    if (websiteURL) {
      // restored from snapshot (e.g. browser back): the report is already on screen, no rescan
      const currentKey = `${websiteURL}|${standard}`;
      if (restoredKey.current === currentKey) return;
      restoredKey.current = null;

      setScreenError(false)
      ScanningProcessService(websiteURL, 2, getScanLang(), dispatch, setViolationsGroupList, setErrorViolationsTotal, setErrorViolationsTotalFixedByWidget, setSuccessViolationsTotal, setAccessibilitySystemDetected, setRequestDataObj, setScreenError, setApiRecall, pid, isFromScript);
    }

  }, [websiteURL, standard])

  console.log("title", title);
  

  // Scan Result

  const [apiRecall, setApiRecall] = useState(false);

  const [fixedByWidget, setFixedByWidget] = useState(false);

  const [violationsGroupList, setViolationsGroupList] = useState<groupDataMainPropTypes | undefined>(initialSnapshot?.violationsGroupList);

  const [filteredviolationsGroupList, setFilteredViolationsGroupList] = useState<groupDataMainPropTypes | undefined>(initialSnapshot?.violationsGroupList);
  const [requestDataObj, setRequestDataObj] = useState<requestDataProptype | undefined>(initialSnapshot?.requestDataObj);

  const [errorViolationsTotal, setErrorViolationsTotal] = useState<number>(initialSnapshot?.errorViolationsTotal ?? 0);
  const [successViolationsTotal, setSuccessViolationsTotal] = useState<number>(initialSnapshot?.successViolationsTotal ?? 0);
  const [errorViolationsTotalFixedByWidget, setErrorViolationsTotalFixedByWidget] = useState<number>(initialSnapshot?.errorViolationsTotalFixedByWidget ?? 0);

  const [accessibilitySystemDetected, setAccessibilitySystemDetected] = useState<string>(initialSnapshot?.accessibilitySystemDetected ?? '');

  const [screenError, setScreenError] = useState<boolean>(false);
  const [fullScreenLoading, setFullScreenLoading] = useState<boolean>(false);

  // Language change refetch: keep the report on screen instead of showing the loader
  const [isLangRefetching, setIsLangRefetching] = useState<boolean>(false);
  const sawProgress = useRef<boolean>(false);
  const langTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const prevLang = useRef<string>(i18n.language);
  const isRtl = i18n.dir() === 'rtl';


  useEffect(() => {
      // check if loading is active
      if (ispidLoading) {
          setFullScreenLoading(true);
      } else {
          setFullScreenLoading(false);
      }
  }, [ispidLoading])

  useEffect(() => {
    if (violationsGroupList) {
      setFilteredViolationsGroupList(violationsGroupList);
    }

  }, [violationsGroupList])

  const demoFunction = () => {
    /* console.log("demo function");
    console.log("scaningProcess", scaningProcess);
    console.log("websiteURL", websiteURL);
    console.log("scaningProcessPer", scaningProcessPer); */
    if (scaningProcess && websiteURL && scaningProcessPer !== 100) {
      ScanningProcessService(websiteURL, 1, getScanLang(), dispatch, setViolationsGroupList, setErrorViolationsTotal, setErrorViolationsTotalFixedByWidget, setSuccessViolationsTotal, setAccessibilitySystemDetected, setRequestDataObj, setScreenError, setApiRecall, pid, isFromScript);
    }
  }

  useEffect(() => {
    if (reScaningProcess && !scaningProcess) {
      setApiRecall(false);
    }
  }, [reScaningProcess, scaningProcess])

  useEffect(() => {
    if (apiRecall) {
      /* console.log("apiRecall use effect"); */
      setApiRecall(false);
      setTimeout(demoFunction, 2000);
      window.parent.postMessage({type: "IS_LOADER_SHOW"}, "*");
    }
  }, [apiRecall])

  useEffect(() => {
    const dir = i18n.dir(i18n.language);          // 'rtl' | 'ltr'
    const html = document.documentElement;
    html.setAttribute('dir', dir);
    html.setAttribute('lang', i18n.language);
    html.classList.toggle('is-rtl', dir === 'rtl');
  }, [i18n.language]);

  // Accessibility Score

  const [accessibilityScore, setAccessibilityScore] = useState<number | null>(initialSnapshot?.accessibilityScore ?? null);
  const [groupAccessibilityScore, setGroupAccessibilityScore] = useState<tempGropScorePropType>();
  const [finalGroupAccessibilityScore, setFinalGroupAccessibilityScore] = useState<finalGropTotalScorePropType>();

  useEffect(() => {
    if (violationsGroupList) {
      let keyObjScore: tempGropScorePropType = {};
      Object.keys(violationsGroupList).map((keyname) => {
        violationsGroupList[keyname].map((violation) => {
          let tempScore;
          if (fixedByWidget && violation.is_fixed_by_widget) {
            tempScore = 100;
            const tempObjValue = keyObjScore[keyname] ? { [keyname]: [...keyObjScore[keyname], tempScore] } : { [keyname]: [tempScore] }
            keyObjScore = { ...keyObjScore, ...tempObjValue }
          }
          else {
            if (violation.total_error > 0 || violation.total_success > 0) {
              if (violation.total_success > 0) {
                tempScore = parseInt(((violation.total_success / (violation.total_success + violation.total_error)) * 100).toFixed(2));
              } else {
                tempScore = 0;
              }
              const tempObjValue = keyObjScore[keyname] ? { [keyname]: [...keyObjScore[keyname], tempScore] } : { [keyname]: [tempScore] }
              keyObjScore = { ...keyObjScore, ...tempObjValue }
            }
            /*  else{ 
               tempScore = 100;
             } */

          }
        })
      })
      setGroupAccessibilityScore(keyObjScore);
    }
  }, [violationsGroupList, fixedByWidget])


  // Grop Score
  useEffect(() => {
    if (groupAccessibilityScore) {
      console.log("groupAccessibilityScore", groupAccessibilityScore);
      let tempObj: finalGropTotalScorePropType = {}
      Object.keys(groupAccessibilityScore).map((keyname, gIndex) => {
        const sum = groupAccessibilityScore[keyname].reduce((accumulator, currentValue) => {
          return accumulator + currentValue
        }, 0);
        const persentage = sum / groupAccessibilityScore[keyname].length;
        tempObj = { ...tempObj, [keyname]: persentage }
      })
      setFinalGroupAccessibilityScore(tempObj);
    }
  }, [groupAccessibilityScore])


  useEffect(() => {
    if (finalGroupAccessibilityScore) {
      console.log("finalGroupAccessibilityScore", finalGroupAccessibilityScore);
      let sum = 0;
      Object.keys(finalGroupAccessibilityScore).map((keyname, gIndex) => {
        sum = sum + finalGroupAccessibilityScore[keyname];
      })
      const persentage = sum / Object.keys(finalGroupAccessibilityScore).length;
      setAccessibilityScore(persentage);
    }
  }, [finalGroupAccessibilityScore]);

  // Save the finished report so it can be restored after unmount (browser back).
  // i18n.language / standard are intentionally NOT dependencies: otherwise old data
  // could be saved under the new key at the moment the language/standard changes.
  useEffect(() => {
    if (
      violationsGroupList && requestDataObj && accessibilityScore !== null &&
      websiteURL && scaningProcessPer === 100 && !isLoading && !isLangRefetching &&
      scanLangRef.current === i18n.language
    ) {
      scanSnapshot = {
        key: `${websiteURL}|${standard}`,
        lang: scanLangRef.current,
        violationsGroupList,
        requestDataObj,
        errorViolationsTotal,
        successViolationsTotal,
        errorViolationsTotalFixedByWidget,
        accessibilitySystemDetected,
        accessibilityScore,
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [violationsGroupList, requestDataObj, accessibilityScore, websiteURL, scaningProcessPer, isLoading, isLangRefetching,
      errorViolationsTotal, successViolationsTotal, errorViolationsTotalFixedByWidget, accessibilitySystemDetected]);



  /* useEffect(() => {
    if (errorViolationsTotal > 0 && successViolationsTotal > 0) {
      let score = 0;
      if (fixedByWidget) {
        score = (successViolationsTotal + errorViolationsTotalFixedByWidget) / (errorViolationsTotal + successViolationsTotal) * 100;
      }
      else {
        score = successViolationsTotal / (errorViolationsTotal + successViolationsTotal) * 100;
      }
      setAccessibilityScore(score);
    }
    else if (errorViolationsTotal === 0 && successViolationsTotal > 0) {
      setAccessibilityScore(100);
    }
    else if (errorViolationsTotal > 0 && successViolationsTotal === 0) {
      setAccessibilityScore(0);
    }

  }, [successViolationsTotal, errorViolationsTotal, errorViolationsTotalFixedByWidget, fixedByWidget]) */


  interface ForwardedRefs {
    scoreRef: React.RefObject<HTMLDivElement>;
    wcagRef: React.RefObject<HTMLDivElement>;
  }

  const forwardedRefs = useRef<ForwardedRefs>({
    scoreRef: useRef<HTMLDivElement>(null),
    wcagRef: useRef<HTMLDivElement>(null),
  });

  const [scoreImage, setScoreImage] = useState<string>('');
  const [wcagImage, setWCAGImage] = useState<string>('');

  

  const GetScreenshot = async () => {
    await document.fonts?.ready;

    const scoreEl = forwardedRefs.current.scoreRef.current;
    const wcagEl = forwardedRefs.current.wcagRef.current;
    if (!scoreEl || !wcagEl) return null;

    // show numbered circles in the image (needed for the desktop dot layout)
    const legends = [scoreEl, wcagEl].flatMap((el) =>
      Array.from(el.querySelectorAll<HTMLElement>(".levels-legend"))
    );
    legends.forEach((l) => l.classList.add("is-capture"));

    try {
      const [scoreUrl, wcagUrl] = await Promise.all([
        toPng(scoreEl, { cacheBust: true }),
        toPng(wcagEl, { cacheBust: true }),
      ]);
      setScoreImage(scoreUrl);
      setWCAGImage(wcagUrl);
      return { scoreUrl, wcagUrl };
    } catch (err) {
      console.log(err);
      return null;
    } finally {
      legends.forEach((l) => l.classList.remove("is-capture"));
    }
  };

  useEffect(() => {
    let t: number;
    const onResize = () => {
      window.clearTimeout(t);
      t = window.setTimeout(GetScreenshot, 300);
    };
    window.addEventListener("resize", onResize);
    GetScreenshot()
    return () => {
      window.removeEventListener("resize", onResize);
      window.clearTimeout(t);
    };
  }, []);

  // ---------- Language change refetch (no loader) ----------

  const finishLangRefetch = () => {
    if (langTimer.current) clearTimeout(langTimer.current);
    sawProgress.current = false;
    setIsLangRefetching(false);
  };

  // Shared by language change and browser back: keep the report visible while a rescan runs
  const startSilentRefetch = () => {
    setIsLangRefetching(true);
    sawProgress.current = false;

    // very long safety net so the flag can never stay on forever
    if (langTimer.current) clearTimeout(langTimer.current);
    langTimer.current = setTimeout(finishLangRefetch, 5 * 60 * 1000);

    // if no scan/loading ever starts (e.g. cached result), release the flag
    setTimeout(() => {
      if (!sawProgress.current) finishLangRefetch();
    }, 5000);
  };

  // 1) start refetch when language changes.
  // useLayoutEffect sets the flag BEFORE the browser paints, so there is no
  // frame where isLoading is true and isLangRefetching is still false.
  useLayoutEffect(() => {
    if (prevLang.current === i18n.language) return;
    prevLang.current = i18n.language;

    if (violationsGroupList && websiteURL) {
      setIsLangRefetching(true);
      sawProgress.current = false;

      // 2) no short timer: only a very long safety net (5 min), so a slow scan
      // never drops the report and shows the loader again
      if (langTimer.current) clearTimeout(langTimer.current);
      langTimer.current = setTimeout(finishLangRefetch, 5 * 60 * 1000);

      ScanningProcessService(websiteURL, 1, getScanLang(), dispatch, setViolationsGroupList, setErrorViolationsTotal, setErrorViolationsTotalFixedByWidget, setSuccessViolationsTotal, setAccessibilitySystemDetected, setRequestDataObj, setScreenError, setApiRecall, pid, isFromScript);
    }
  }, [i18n.language])

  // Safety net: report was scanned in one language but the UI is in another
  // (e.g. back button -> Arabic UI, but the scan used a different language). Refetch silently.
  useEffect(() => {
    if (!violationsGroupList || !websiteURL || screenError) return;
    if (scaningProcessPer !== 100 || isLoading || isLangRefetching) return;
    if (scanLangRef.current && scanLangRef.current !== i18n.language) {
      startSilentRefetch();
      ScanningProcessService(websiteURL, 1, getScanLang(), dispatch, setViolationsGroupList, setErrorViolationsTotal, setErrorViolationsTotalFixedByWidget, setSuccessViolationsTotal, setAccessibilitySystemDetected, setRequestDataObj, setScreenError, setApiRecall, pid, isFromScript);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language, violationsGroupList, scaningProcessPer, isLoading, isLangRefetching]);

  // 3) finish only when the scan reaches 100% again (after it has actually
  // restarted) AND the global loading flag is off
  useEffect(() => {
    if (!isLangRefetching) return;
    if (scaningProcessPer < 100 || isLoading) {
      sawProgress.current = true;
    } else if (sawProgress.current) {
      finishLangRefetch();
    }
  }, [scaningProcessPer, isLoading, isLangRefetching]);

  // stop on error
  useEffect(() => {
    if (screenError) finishLangRefetch();
  }, [screenError]);

  // cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (langTimer.current) clearTimeout(langTimer.current);
    };
  }, []);

  const refetchForLanguage = () => {
    if (!websiteURL) return;
    startSilentRefetch();
    ScanningProcessService(websiteURL, 1, getScanLang(), dispatch, setViolationsGroupList, setErrorViolationsTotal, setErrorViolationsTotalFixedByWidget, setSuccessViolationsTotal, setAccessibilitySystemDetected, setRequestDataObj, setScreenError, setApiRecall, pid, isFromScript);
  };

  // Home just remounted (e.g. back from Privacy/Terms) and the language changed while it was away
  useEffect(() => {
    if (initialSnapshot && initialSnapshot.lang !== i18n.language) {
      refetchForLanguage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function getHeadline(title:string) {
    if (title && title.trim() !== '') {
      return title;
    }

    return (
      <>
        <Trans i18nKey='landing-headline'>  
          Our free <h1>ADA and WCAG compliance checker</h1>
          identifies web accessibility issues
        </Trans> 
      </>
    );
  }



  //const [ipAddress, setIpAddress] = useState('');
  //const [countryCode, setCountryCode] = useState('');

  /* useEffect(() => {
    axios.get('https://ipapi.co/json/')
      .then(response => {
        const ipData = response.data;
        setIpAddress(ipData.ip);
        //setCountryCode(ipData.country_code);
      })
      .catch(error => console.error(error));
  }, []); */

  // Which screen to show
  const showLanding = !isLangRefetching && !scaningProcess && !reScaningProcess;

  const showReport =
    !!filteredviolationsGroupList &&
    accessibilityScore !== null &&
    (!isLoading || isLangRefetching);

  return (
    <>
      {fullScreenLoading && (
        <>
          <div role="alert" className="aioa_checker-fullscreen-loader" aria-live='polite'>
              <div className="aioa_checker-loader">
                  <img src={LodingImg} alt="" />
                  <span className="visually-hidden">{t("Loading page. Please Do not refresh the page")} </span>
              </div>
          </div>
        </>
      )}
      <ThemeProvider dir={i18n.dir(i18n.language)}>
        <MainTemplate>
          
          <MetaDataProivder />


          <div className={`page-content show-lang`}>
          {/* <div className={`page-content ${ipAddress === '59.97.182.246' ? 'show-lang' : ''}`}> */}

            {screenError ? (
              <>
                <div className="error-page-wrapper">
                  <Container>
                      <div className='logo-wrapper'>
                        <img src={logo} alt={t('logo-alt-text')} />
                      </div>
                    <div className='graphics-form-wrapper'>
                      <div className='error-image-wrapper'>
                        <img src={errorImage} alt="" />
                      </div>
                      <div className='error-text-form-wrapper text-center'>
                        <h2 className='h1'>{t("Website Connection Error")}</h2>
                        <p>
                          <Trans components={{ br: <br />, a: <a /> }}>{t('Connection Error Message')}</Trans>
                        </p>
                        <ScanURLFormComponents />
                      </div>
                    </div>
                  </Container>
                  <Container className='report-a-problem-link'>
                    <Link to="/report-a-problem">{t("Report a Problem")}</Link>
                  </Container>
                </div>
              </>
            ) : (
              <>
                {showLanding ? (
                  <>
                    <Container fluid className="landing-page-wrapper">
                      <Row className="h-100">
                        {!isWhiteLabel && (
                          <>
                            {windowWidth > 1560 ?
                              <Col className="hero-image-wrapper d-flex align-items-center justify-content-center p-5">
                                <img src={isRtl ? heroImageRtl : heroImage} alt="" />
                              </Col>
                              : <></>
                            }
                          </>
                        )}

                        <Col className={`${windowWidth > 1560 ? 'd-flex' : ''}`}>
                          <div className={`left-wrapper ${isWhiteLabel ? 'w-100' : ''}`}>
                            <CustomHeader isWhiteLabel={isWhiteLabel}/>
                            <main className="form-wrapper">
                              <Container>
                                <div className='heading'>
                                  {getHeadline(title)}
                                </div>
                                <ScanURLFormComponents isWhiteLabel={isWhiteLabel}/>


                              </Container>

                            </main>
                            {!isWhiteLabel && (
                              <Footer />
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </>
                ) : (
                  <>

                    {showReport ? (
                      <>
                        <div className="page-content-inner">
                          {/* {fixedByWidget ? <div className="star-background">
                            <div className="flash"></div>
                          </div>
                            : <></>
                          } */}

                          <div className='scan-details-page-main'>
                            <CustomHeader isWhiteLabel={isWhiteLabel}/>
                            <main>
                              <div className='light-bg pb-4 pb-lg-5'>
                                {websiteURL ? <>
                                  <div className='report-url-pdf-section'>
                                    <Container>
                                      <h1 className='url'>
                                        <Trans
                                          i18nKey="Accessibility report for"
                                          defaults="Accessibility report for <bold>{{- website}}</bold>"
                                          values={{
                                            website: getWebsiteName(websiteURL) ?? websiteURL,
                                          }}
                                          components={{
                                            bold: <strong />,
                                          }}
                                        />
                                      </h1>
                                      {requestDataObj ? <DownloadReport requestDataObj={requestDataObj} GetScreenshot={GetScreenshot} scoreImage={scoreImage} wcagImage={wcagImage} isWhiteLabel={isWhiteLabel}/> : <></>}
                                    </Container>
                                  </div>
                                </> : <></>}

                                {requestDataObj ? <>

                                </> : <></>}
                                {(accessibilityScore !== null) ? <>
                                  <WebsiteURLSection
                                    accessibilitySystemDetected={accessibilitySystemDetected}
                                    accessibilityScore={accessibilityScore}
                                    errorViolationsTotal={errorViolationsTotal}
                                    errorViolationsTotalFixedByWidget={errorViolationsTotalFixedByWidget}
                                    fixedByWidget={fixedByWidget}
                                    setFixedByWidget={setFixedByWidget}
                                    ref={forwardedRefs}
                                    isWhiteLabel={isWhiteLabel}
                                  />
                                </> : <></>}


                              </div>
                              <Container>

                                {requestDataObj ?
                                  <AccessibilityViolationsList
                                    fixedByWidget={fixedByWidget}
                                    violationsGroupList={filteredviolationsGroupList}
                                    isWhiteLabel={isWhiteLabel}
                                  />
                                  : <></>
                                }
                                {/* {!isWhiteLabel && (

                                  <div className='site-footer'>

                                    {(accessibilitySystemDetected !== '' && accessibilitySystemDetected !== null && accessibilitySystemDetected !== "All in One Accessibility™") ?
                                      <AllInOneAccessibilityCTA />
                                      : (
                                        <>
                                          {isPaidFree ? (
                                            <>
                                              {isPaidFree === 2 ? <>

                                              </> : <>
                                                <AllInOneAccessibilityCTA />
                                              </>}

                                            </>
                                          ) : (
                                            <>
                                              <AllInOneAccessibilityCTA />
                                            </>
                                          )}
                                        </>
                                      )}



                                    <div className="cts-box">
                                      <div className="cts-box-text">
                                        <h2 className="h3 mb-3">{t("Manual Accessibility Audit Title")}</h2>
                                        <p>{t("Manual Accessibility Audit Description")}</p>
                                      </div>
                                      <div className="cts-box-btn">
                                        <a href="https://www.skynettechnologies.com/website-accessibility-audit" className="btn btn-light" target='_blank'>
                                          <span>{t("Request Manual Accessibility Audit")}</span>
                                          <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 9.5 16">
                                            <path d="M1.5,0L0,1.5L6.5,8L0,14.5L1.5,16l8-8L1.5,0z"></path>
                                          </svg>
                                        </a>
                                      </div>
                                    </div>

                                  </div>
                                )} */}


                                {(accessibilitySystemDetected !== ''
                                && accessibilitySystemDetected !== null
                                && accessibilitySystemDetected !== "All in One Accessibility™") // check if all in one accessibility is detected
                                ?
                                <>
                                    {!isWhiteLabel && (
                                        <ManualAuditBanner />
                                    )}
                                </>
                                : (
                                    <>
                                        {isPaidFree ? // check if widget flag is available
                                            (
                                                <>
                                                    {isPaidFree === 2 // check if widget paid
                                                        ? <>
                                                            {!isWhiteLabel && (
                                                                // <ScanningMonitoringPromoBanner />
                                                                <ManualAuditBanner />
                                                            )}
                                                        </> : <>
                                                            {!isWhiteLabel && (
                                                                <AIOAPromoBanner />
                                                            )}
                                                        </>}

                                                </>
                                            ) : (
                                                <>
                                                    {!isWhiteLabel && (
                                                        <AIOAPromoBanner />
                                                    )}
                                                </>
                                            )}
                                    </>
                                )}
                                {!isWhiteLabel && (
                                  <div className="accessibility-consult-box">
                                    <div className="consult-text">
                                      <h3>{t('looking_for_expert')}</h3>
                                      <p>
                                        <Trans
                                          i18nKey="our_team_assist"
                                          components={{ strong: <strong /> }}
                                        />
                                      </p>
                                      <ul>
                                        <li>✔ {t('manualReview')}</li>
                                        <li>✔ {t('accessibilityStatementDocument')}</li>
                                        <li>✔ {t('pricingSupport')}</li>
                                      </ul>
                                    </div>
                                    <div className="consult-action">
                                      <a href="https://www.skynettechnologies.com/full-website-accessibility-remediation#consultationform" target='_blank' className="consult-btn">
                                      {t('schedule_call')}
                                      </a>
                                    </div>
                                  </div>
                                )}


                              </Container>

                            </main>
                            {!isWhiteLabel && (
                              <div className='mt-5'>
                                <Footer />
                              </div>
                            )}
                          </div>
                        </div>

                      </>
                    ) : (
                      <>
                        <CustomLoader isWhiteLabel={isWhiteLabel}/>
                      </>
                    )}



                  </>
                )}
              </>
            )}

          </div>

        </MainTemplate >
      </ThemeProvider>
    </>
  )

}

export default Home;